export default __webpack_public_path__ + "static/media/contribute-two.0c853a94.png";